export default __webpack_public_path__ + "b488973e78332186d6102592a336c34d.png";